<template>
    <div class="declare-panel">
        <div class="panel-head">快速營業稅申報</div>
        <div class="section">
            <div class="section-head">1-1. 請選擇本次申報所屬期別</div>
            <div class="section-body">
                <div>
                    <el-select
                        v-model="period"
                        placeholder="請選擇"
                        value-key="key"
                        style="width: 100%; max-width: 300px"
                        @change="fetchInvoicePrefixData"
                    >
                        <el-option
                            v-for="item in periodList"
                            :key="`${item.year}-${item.value}-${item.period}`"
                            :label="`${item.year - 1911}年 ${item.period}`"
                            :value="item"
                        />
                    </el-select>
                    <div style="font-size: 10pt; margin-top: 10px; color: #aaa">
                        <span>（申報期限：</span>
                        <span v-if="period.period === '1～2月'">{{ period.year - 1911 }} 年 3 月 15 日</span>
                        <span v-if="period.period === '3～4月'">{{ period.year - 1911 }} 年 5 月 15 日</span>
                        <span v-if="period.period === '5～6月'">{{ period.year - 1911 }} 年 7 月 15 日</span>
                        <span v-if="period.period === '7～8月'">{{ period.year - 1911 }} 年 9 月 15 日</span>
                        <span v-if="period.period === '9～10月'">{{ period.year - 1911 }} 年 11 月 15 日</span>
                        <span v-if="period.period === '11～12月'">{{ period.year + 1 - 1911 }} 年 1 月 15 日</span>
                        <span>）</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="section-head">1-2. 確認該期發票字軌號碼已登記</div>
            <div class="section-body">
                <el-table
                    v-loading="isLoading"
                    :data="invoicePrefixList"
                    style="width: 100%"
                    class="ah-el-data-table"
                >
                    <template slot="empty">
                        <div v-if="isLoading">載入中</div>
                        <div v-else>尚未設定該期發票字軌</div>
                    </template>
                    <el-table-column label="年份" width="70" prop="yer">
                        <template slot-scope="scope"> {{ scope.row.yer - 1911 }} 年 </template>
                    </el-table-column>
                    <el-table-column label="期別" width="110">
                        <template slot-scope="scope">
                            <div>
                                <span v-if="scope.row.moN_TYP === 1">1 ～ 2 月</span>
                                <span v-if="scope.row.moN_TYP === 2">3 ～ 4 月</span>
                                <span v-if="scope.row.moN_TYP === 3">5 ～ 6 月</span>
                                <span v-if="scope.row.moN_TYP === 4">7 ～ 8 月</span>
                                <span v-if="scope.row.moN_TYP === 5">9 ～ 10 月</span>
                                <span v-if="scope.row.moN_TYP === 6">11 ～ 12 月</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="類型" width="150">
                        <template slot-scope="scope">
                            <span v-if="scope.row.prefixType === 1">手開發票</span>
                            <span v-if="scope.row.prefixType === 2">電子發票串接</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="字軌號碼(起)" width="150">
                        <template slot-scope="scope">
                            <span class="strong">{{ scope.row.startPrefix }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="字軌號碼(訖)" width="150">
                        <template slot-scope="scope">
                            <span class="strong">{{ scope.row.endPrefix }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center">
                        <template slot-scope="scope">
                            <el-button v-if="isAuth('F24') && !isQR()" size="mini" @click="onInvoicePrefixEdit(scope.row)">編輯</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="isAuth('F24') && !isQR()" style="padding: 10px 0">
                    <el-button size="small" icon="el-icon-plus" @click="onAddInvoicePrefix">新增字軌</el-button>
                </div>
                <div v-if="!isLoading && invoicePrefixList.length === 0 && !isAuth('F24')" style="margin-top: 10px;">
                    <el-alert
                        type="warning"
                        :closable="false"
                        style="padding-top: 3px;"
                    >請提醒財務人員至「設定 / 發票字軌管理」中登記。</el-alert>
                </div>
            </div>
        </div>
        <div class="panel-footer">
            <el-button type="primary" :disabled="isQR()" @click="onNextStep">開始申報銷項 <i class="el-icon-arrow-right"/></el-button>
        </div>
        <InvoiceSerialNumberDialog
            ref="InvoiceSerialNumberDialog"
            :visible="editDialog.visible"
            :mode="editDialog.mode"
            :target="editDialog.target"
            :queryYER="period.year"
            @afterSubmit="handleAfterSubmit"
            @afterDelete="handleAfterDelete"
            @close="onInvoicePrefixDialogClose"
        />
    </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import InvoiceSerialNumberDialog from '@/components/dashboard/Finance/InvoiceSerialNumber/InvoiceSerialNumberDialog.vue';

export default {
    components: {
        InvoiceSerialNumberDialog,
    },
    data() {
        return {
            isLoading: false,
            invoicePrefixList: [],
            editDialog: {
                visible: false,
                mode: 'CREATE',
                target: null,
            },
        };
    },
    computed: {
        ...mapState({
            statePeriod: (state) => state.businessTax.period,
            storePeriodYear: (state) => state.businessTax.periodYear,
            declarePeriod: (state) => state.businessTax.declarePeriod,
            declarePeriodYear: (state) => state.businessTax.declarePeriodYear,
            periodList: (state) => state.businessTax.periodList,
        }),
        period: {
            get() {
                return this.periodList?.find((o) => o.value === this.declarePeriod && o.year === this.declarePeriodYear);
            },
            set(val) {
                this.setDeclarePeriod(val);
            },
        },
    },
    created() {
        this.updateQuery({ QueryType: 1 });
        if (!this.period) {
            if (this.declarePeriod) {
                this.period = this.periodList.find((o) => o.value === this.declarePeriod && o.year === this.declarePeriodYear);
            } else {
                this.period = this.periodList.find((o) => o.value === this.statePeriod && o.year === this.storePeriodYear);
            }
        }
    },
    mounted() {
        this.fetchInvoicePrefixData();
    },
    methods: {
        ...mapMutations({
            setDeclarePeriod: 'businessTax/setDeclarePeriod',
            updateQuery: 'businessTax/updateQuery',
        }),
        onNextStep() {
            this.$router.push({ name: 'accounting-business-tax-quick-declare-step-2' });
        },
        async fetchInvoicePrefixData() {
            this.isLoading = true;
            try {
                // 取得該年度字軌號碼
                const resp = await this.$api({
                    url: '/InvoicePrefix/GetList',
                    params: {
                        YER: this.period.year,
                        PREFIX: null,
                        PageSize: 25,
                        PageNum: 1,
                    },
                    method: 'GET',
                });

                // 只取得選定的期別
                let targetMonTyp = 0;
                switch (this.period.period) {
                case '1～2月': targetMonTyp = 1; break;
                case '3～4月': targetMonTyp = 2; break;
                case '5～6月': targetMonTyp = 3; break;
                case '7～8月': targetMonTyp = 4; break;
                case '9～10月': targetMonTyp = 5; break;
                case '11～12月': targetMonTyp = 6; break;
                default:
                }
                this.invoicePrefixList = resp.data.list.filter((d) => d.moN_TYP === targetMonTyp);
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        onAddInvoicePrefix() {
            this.editDialog.mode = 'CREATE';
            this.editDialog.target = null;
            this.editDialog.visible = true;
        },
        onInvoicePrefixEdit(data) {
            this.editDialog.mode = 'EDIT';
            this.editDialog.target = data;
            this.editDialog.visible = true;
        },
        onInvoicePrefixDialogClose() {
            this.editDialog.visible = false;
            this.editDialog.target = null;
        },
        handleAfterSubmit() {
            this.fetchInvoicePrefixData();
        },
        handleAfterDelete() {
            this.fetchInvoicePrefixData();
        },
    },
};
</script>
<style lang="scss">
.declare-panel {
    padding: 60px;
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 10px;

    >.panel-head {
        font-size: 18pt;
        font-weight: bold;
        margin-bottom: 50px;
    }

    >.section {
        margin-bottom: 40px;
        >.section-head {
            font-size: 11pt;
            font-weight: bold;
            margin-bottom: 25px;
            padding: 8px 0;
            border-bottom: 1px solid #000;
        }
    }

    >.panel-footer {
        .el-button {
            width: 100%;
            height: 50px;
        }
    }
}
</style>
